<!--
 * @Author: ts.r
 * @Date: 2020-10-26 10:58:56
 * @LastEditTime: 2021-02-07 19:50:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cmine-pro-fe/src/components/enroll/ImgCode.vue
-->
<template>
  <span v-if="src" class="img-code-wrap" @click="changeImg">
    <img :src="src" alt="" />
  </span>
</template>
<script>
import { msgTip } from '@/utils/urlUtils'
export default {
  name: 'ImgCode',
  components: {},
  data() {
    return {}
  },
  props: {
    src: {
      default: '',
      type: String
    }
  },
  methods: {
    changeImg() {
      this.$emit('get_new_img')
    }
  }
}
</script>
<style lang="scss">
.img-code-wrap {
  border: 1px solid #fff;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  display: inline-block;
  img {
    width: 120px;
    height: 48px;
    border-radius: 4px;
  }
}
</style>
